/* eslint-disable max-len */
import React, { useRef, useState } from 'react';
import InputField from '../../../../../components/InputFeld';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';

const BankOD = ({
    recodes,
    handleOnchangeInput,
    exitVal,
    selectedGroupType,
    getListOfGroup,
    handelCheckboxType
}) => {
    const [isSelectDropdown, setIsSelectDropdown] = useState(false);
    const bank_type = ["Savings Account", "Current Account"];
    const outsideClickRef = useRef();

    /* The above code is using the `useOnClickOutside` hook to handle a click event outside of a
    specific element referenced by `outsideClickRef`. When the click event occurs outside of the
    element, it sets the state variable `isSelectDropdown` to `false`. */
    useOnClickOutside(outsideClickRef, () => {
        setIsSelectDropdown(false);
    });
    return (
        <>
            <div class="Bank_OD_details">
                <p class="text-base font-semibold text-[#031624] mb-2">Bank Account Details</p>
                <div class="border border-[#D0D5DD] p-3 rounded bg-[#fff]">
                    {/* <!-- bank account details section --> */}
                    <div class="">
                        <div class="flex xl:-mx-10 2xl:-mx-[100px]">
                            <div class="w-[46%] xl:px-10 2xl:px-[100px]">
                                <div class="w-full">
                                    <div class="flex items-center w-full mb-4">
                                        <label for="accName" class="text-f7 font-normal text-[#031624] min-w-[150px] inline-flex">Acc. Holder Name<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"account_holder_name"}
                                            inputLabel={"Account Holder Name"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Acc. Holder Name"}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.account_holder_name === "") ? "Account Holder Name is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.account_holder_name}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full mb-4">
                                        <label for="Account_No" class="text-f7 font-normal text-[#031624] min-w-[150px] inline-flex">Account No.<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"account_number"}
                                            inputLabel={"Account Number"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Account No."}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.account_number === null) ? "Account Number is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.account_number}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full mb-4">
                                        <label for="Account_No" class="text-f7 font-normal text-[#031624] min-w-[150px] inline-flex">Account Type</label>
                                        {/* <!-- for pre-filled disabled input: text-[#4D555B] bg-[#E6E8EA] otherwise bg-[#fff] text-[#031624] --> */}
                                        {
                                            selectedGroupType === "Bank OD Account" ? 
                                                <input type="text" id="Account_No" class="border border-[#D0D5DD] rounded w-full px-3.5 py-1.5 text-f7 font-normal text-[#4D555B] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 bg-[#E6E8EA]" placeholder="Enter Account No." value="OD Account"/>
                                                :
                                                <div ref={outsideClickRef} class="relative w-full" data-te-dropdown-ref="">
                                                    {/* <!-- for disabled bg-[#E6E8EA] --> */}
                                                    <button
                                                        onClick={()=> {getListOfGroup(); setIsSelectDropdown(!isSelectDropdown)}}
                                                        class={`${(exitVal && recodes?.account_type === "") ? "redBorder" : ""} slct-inpt-fld transition duration-150 ease-in-out bg-[#fff] debitNCredit" type="button`} id="dropdownMenu_acdemic_year" data-te-dropdown-toggle-ref="" aria-expanded="false">
                                                        <p class={`text-f7 ${ recodes?.account_type === "" ? "text-[#818E98]" : "text-[#344054] "} font-normal`}>{recodes?.account_type === "" ? "Select Account Type" : recodes.account_type}</p>
                                                        <img src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${isSelectDropdown? "transform rotate-180" : ""}`}/>
                                                    </button>
                                                    {isSelectDropdown && <ul class="slct_drp_dwn min-w-full [&amp;[data-te-dropdown-show]]:block" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref="">
                                                        <li class="max-h-[160px] overflow-auto scroll-bar">
                                                            <ul>
                                                                {bank_type.map((item) => (
                                                                    <li key={item}>
                                                                        <p 
                                                                            onClick={() => {
                                                                                handelCheckboxType(item, "account_type");
                                                                                setIsSelectDropdown(false)
                                                                            }}
                                                                            class="block w-full whitespace-wrap bg-white pr-2 mb-2 text-f7 font-normal text-[#031624] cursor-pointer" data-te-dropdown-item-ref="">
                                                                            {item}
                                                                        </p>
                                                                    </li>))}
                                                            </ul>
                                                        </li>
                                                    </ul>}
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="w-[54%] xl:px-10 2xl:px-[100px] flex">
                                <div class="w-[85%]">
                                    <div class="flex items-center w-full mb-4">
                                        <label for="Bank_Name" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex">Bank Name<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"bank_name"}
                                            inputLabel={"Bank Name"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Bank Name"}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.bank_name === "") ? "Bank Name is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.bank_name}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full mb-4">
                                        <label for="Branch_Name" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex">Branch Name<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"branch_name"}
                                            inputLabel={"Branch Name"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Branch Name"}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.branch_name === "") ? "Branch Name is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.branch_name}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full mb-4">
                                        <label for="IFSC_Code" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex">IFSC Code<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"ifsc_code"}
                                            inputLabel={"IFSC Code"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter IFSC Code"}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.ifsc_code === "") ? "IFSC Code is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.ifsc_code}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full">
                                        <label for="Swift_Transfer_Code" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex">Swift Transfer Code</label>
                                        <InputField
                                            inputId={"swift_transfer_code"}
                                            inputLabel={"Swift Transfer Code"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Swift Transfer Code"}
                                            inputDisabled={false}
                                            inputErrorMessage={""}
                                            inputMaxLength={30}
                                            inputValue={recodes.swift_transfer_code}
                                            inputChange={handleOnchangeInput}
                                            optional={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BankOD;
